import React from 'react';
import { Link } from 'react-router-dom';
import Badge from './Badge.jsx';
import { ArticleThumbnail } from './CoverThumbnail.jsx';

function ArticleCard({ article }) {
  const {
    title = 'Untitled Article',
    type = 'Original Research',
    authors = '',
    volume = '',
    year = '',
    abstract = '',
    imageUrl = '',
  } = article || {};
  const target = article?.id ? `/articles/${article.id}` : '/articles';

  return (
    <article className="group flex flex-col overflow-hidden rounded-xl border border-bg-border bg-white shadow-sm transition-all hover:-translate-y-1 hover:shadow-lg">
      <Link to={target} className="block aspect-[16/10] w-full flex-shrink-0 overflow-hidden bg-navy">
        <ArticleThumbnail
          src={imageUrl}
          alt={title}
          type={type}
          className="transition-transform duration-300 group-hover:scale-105"
        />
      </Link>

      <div className="flex flex-1 flex-col gap-3 p-5">
        <div className="flex flex-wrap items-center gap-2">
          <Badge type={type} />
          <Badge openAccess />
        </div>

        <h3 className="font-display text-base md:text-lg text-navy font-semibold leading-snug">
          <Link to={target} className="transition-colors hover:text-amber-dark">{title}</Link>
        </h3>

        {authors && (
          <p className="font-sans text-sm text-slate line-clamp-1">
            <span className="font-medium text-gray-700">Authors: </span>
            {authors}
          </p>
        )}

        {abstract && (
          <p className="font-sans text-sm text-gray-600 leading-relaxed line-clamp-3">{abstract}</p>
        )}

        <div className="mt-auto flex flex-wrap items-center justify-between gap-2 border-t border-bg-border pt-3">
          <div className="flex flex-wrap gap-3 text-xs font-sans text-slate">
            {volume && (
              <span className="flex items-center gap-1">
                <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                </svg>
                {volume}
              </span>
            )}
            {year && (
              <span className="flex items-center gap-1">
                <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
                {year}
              </span>
            )}
          </div>
          <Link
            to={target}
            className="flex items-center gap-1 text-xs font-sans font-semibold text-amber transition-colors hover:text-amber-dark"
          >
            Read article
            <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </Link>
        </div>
      </div>
    </article>
  );
}

export default ArticleCard;
